import { create } from 'zustand';
import useLoadingStore from './use-loading';
import { makeRequest } from 'api/api-client';
import { HTTP } from 'constants/http-method';
import { API_ENDPOINTS } from 'api/endpoints';
import { setProfile } from 'utils/profile-storage';

const useApplicantProfileInformationStore = create((set) => ({
  profile: {
    personalDetails: null,
    educationHistory: null,
    employmentHistory: null,
  },

  // Function to get profile details
  getProfileDetails: async () => {
    useLoadingStore.getState().setLoading(true);
    try {
      const { data: response } = await makeRequest(
        HTTP.GET,
        API_ENDPOINTS.APPLICANT_GET_PROFILE_DETAILS
      );
      if (response.success) {
        const {
          userProfile,
          educationHistory,
          employmentHistory,
          emergencyContacts,
        } = response.data?.data || {};
        setProfile(userProfile);
        set({
          profile: {
            educationHistory,
            employmentHistory,
            personalDetails: { ...userProfile, emergencyContacts },
          },
        });
      }
    } catch (error) {
    } finally {
      useLoadingStore.getState().setLoading(false);
    }
  },

  // Function to update personal details
  updatePersonalDetails: async ({ data, successCallback }) => {
    useLoadingStore.getState().setLoading(true);
    try {
      const { data: response } = await makeRequest(
        HTTP.PUT,
        API_ENDPOINTS.APPLICANT_UPDATE_PROFILE,
        data
      );
      if (response.success) {
        const updatedPersonalDetails = response.data?.user;
        set((state) => ({
          profile: {
            ...state.profile,
            personalDetails: { ...updatedPersonalDetails, position: state.profile.personalDetails.position },
          },
        }));
        successCallback && successCallback(response);
      }
    } catch (error) {
    } finally {
      useLoadingStore.getState().setLoading(false);
    }
  },

  // Function to update education history
  updateEducationHistory: async ({ data, successCallback }) => {
    useLoadingStore.getState().setLoading(true);
    try {
      const { data: response } = await makeRequest(
        HTTP.PUT,
        API_ENDPOINTS.APPLICANT_UPDATE_EDUCATION_HISTORY,
        data
      );

      if (response.success) {
        const updatedEducationHistory = response.data;
        set((state) => ({
          profile: {
            ...state.profile,
            educationHistory: updatedEducationHistory,
          },
        }));
        successCallback && successCallback(response);
      }
    } catch (error) {
    } finally {
      useLoadingStore.getState().setLoading(false);
    }
  },

  // Function to add employment history
  addEmploymentHistory: async ({ data, successCallback }) => {
    useLoadingStore.getState().setLoading(true);
    try {
      const { data: response } = await makeRequest(
        HTTP.POST,
        API_ENDPOINTS.APPLICANT_ADD_EMPLOYMENT_HISTORY,
        data
      );

      if (response.success) {
        const updatedEmploymentHistory = response.data.data;
        set((state) => ({
          profile: {
            ...state.profile,
            employmentHistory: updatedEmploymentHistory,
          },
        }));
        successCallback && successCallback(response);
      }
    } catch (error) {
    } finally {
      useLoadingStore.getState().setLoading(false);
    }
  },

  // Function to update employment history
  updateEmploymentHistory: async ({ data, successCallback }) => {
    useLoadingStore.getState().setLoading(true);
    try {
      const { data: response } = await makeRequest(
        HTTP.PUT,
        API_ENDPOINTS.APPLICANT_UPDATE_EMPLOYMENT_HISTORY,
        data
      );

      if (response.success) {
        const updatedEmploymentHistory = response.data.data;
        set((state) => ({
          profile: {
            ...state.profile,
            employmentHistory: updatedEmploymentHistory,
          },
        }));
        successCallback && successCallback(response);
      }
    } catch (error) {
    } finally {
      useLoadingStore.getState().setLoading(false);
    }
  },

  // Function to add employment gap
  addEmploymentGap: async ({ data, successCallback }) => {
    useLoadingStore.getState().setLoading(true);
    try {
      const { data: response } = await makeRequest(
        HTTP.PUT,
        API_ENDPOINTS.APPLICANT_ADD_EMPLOYMENT_GAP,
        data
      );

      if (response.success) {
        set((state) => ({
          profile: {
            ...state.profile,
            employmentHistory: response.data.data,
          },
        }));
        successCallback && successCallback(response);
      }
    } catch (error) {
    } finally {
      useLoadingStore.getState().setLoading(false);
    }
  },
}));

export default useApplicantProfileInformationStore;
